// extracted by mini-css-extract-plugin
export default {"item":"AuctionItem-module__item--PvlEV","sold":"AuctionItem-module__sold--jm19Z","onPodium":"AuctionItem-module__onPodium--CSh7g","price":"AuctionItem-module__price--Jaa+7"};